<template>
  <div>
    <div v-if="errors" class="error_message">{{ message }}</div>
    <el-select
      v-model="videoInputDeviceId"
      :popper-append-to-body="false"
      :no-data-text="$t('checkCamera.无设备')"
      class="check-select-device"
    >
      <el-option
        v-for="item in videoDeviceList"
        :key="item.value"
        :label="item.label"
        :value="item.deviceId"
        @click.native="changeTrack(item.deviceId)"
      >
      </el-option>
    </el-select>
    <video
      id="showCheckVideo"
      autoplay
      muted
      width="240"
      height="134"
      class="check-viedo"
      v-show="videoStream"
    ></video>
    <div v-if="!videoStream" class="check-nocamera">
      <img :src="nocamera" />
    </div>
  </div>
</template>

<script>
import mediaError from "@/mixins/mediaError";
export default {
  name: "checkCamera",
  data() {
    return {
      videoDeviceList: [],
      videoInputDeviceId: null,
      videoStream: null,
      isLoadVideoStream: false,
    };
  },
  mixins: [mediaError],
  computed: {
    rtcClient() {
      return this.$store.getters.rtcClient;
    },
    publishLocal() {
      let publishLocal = null;
      if (
        this.rtcClient &&
        this.rtcClient.RTCRoom &&
        this.rtcClient.RTCRoom.webrtc &&
        this.rtcClient.RTCRoom.webrtc.publishLocal
      ) {
        publishLocal = this.rtcClient.RTCRoom.webrtc.publishLocal;
      }
      return publishLocal;
    },
    webrtc() {
      let webrtc = null;
      if (
        this.rtcClient &&
        this.rtcClient.RTCRoom &&
        this.rtcClient.RTCRoom.webrtc
      ) {
        webrtc = this.rtcClient.RTCRoom.webrtc;
      }
      return webrtc;
    },
  },
  watch: {
    publishLocal: {
      deep: true,
      handler(val) {
        if (
          this.publishLocal &&
          this.publishLocal.errInfo &&
          this.publishLocal.errInfo.video &&
          this.publishLocal.errInfo.video.code == 1
        ) {
          this.videoDeviceList.push({
            label: this.$t("check.nocameradevice"),
            deviceId: null,
          });
          this.$store.commit("SET_VIDEOINPUTDEVICEID", "");
          // this.$parent.loading = false;
        }
        if (val.publishStream && !this.isLoadVideoStream) {
          this.isLoadVideoStream = true;
          this.init();
        }
      },
    },
  },
  async beforeDestroy() {
    // await this.stopVideoTrack();
  },
  methods: {
    async init() {
      await this.setVideoDevice(this.videoInputDeviceId);
      let deviceInfos = await navigator.mediaDevices.enumerateDevices();
      this.videoDeviceList = deviceInfos.filter((d) => {
        return d.kind === "videoinput" && d.deviceId;
      });
      console.log(this.videoDeviceList, "this.videoDeviceList");
      if (!this.videoStream || this.videoDeviceList.length == 0) {
        this.videoDeviceList.push({
          label: this.$t("check.nocameradevice"),
          deviceId: null,
        });
        this.videoInputDeviceId = null;
      } else {
        var videotrackLabel = this.videoStream.getVideoTracks()[0].label;
        const curSelectVideoInput = this.videoDeviceList.find((VideoInput) => {
          return videotrackLabel == VideoInput.label;
        });
        if (curSelectVideoInput) {
          this.videoInputDeviceId = curSelectVideoInput
            ? curSelectVideoInput.deviceId
            : "";
        }
      }
      this.$store.commit("SET_VIDEOINPUTDEVICEID", this.videoInputDeviceId);
      // this.$parent.loading = false;
    },
    async setVideoDevice() {
      // await this.stopVideoTrack();
      // const videoInputDeviceId =
      //   this.videoInputDeviceId != "-1" ? this.videoInputDeviceId : true;
      // console.log(this.videoInputDeviceId, "videoInputDeviceId");
      // let stream = await navigator.mediaDevices
      //   .getUserMedia({
      //     video: { deviceId: videoInputDeviceId, aspectRatio: 16 / 9 },
      //   })
      //   .catch((err) => {
      //     console.log(err.name + ": " + err.message);
      //     this.getUserMediaError(err.name);
      //     return err;
      //   });
      // console.log(stream);
      // if (stream.id && document.getElementById("showCheckVideo")) {
      //   document.getElementById("showCheckVideo").srcObject = stream;
      //   this.videoStream = stream;
      //   console.log(this.videoInputDeviceId);
      //   this.$store.commit("SET_VIDEOINPUTDEVICEID", this.videoInputDeviceId);
      //   console.log(this.$store.getters.VideoInputDeviceId);
      //   this.getUserMediaError("success");
      // }
      document.getElementById("showCheckVideo").srcObject =
        this.publishLocal.publishStream;
      this.videoStream = this.publishLocal.publishStream;
      console.log(this.publishLocal.errInfo, "videostream");
      if(this.publishLocal.errInfo.video){
        this.getUserMediaError(this.publishLocal.errInfo.video.info.name);
      }else{
        this.getUserMediaError("success");
      }

    },
    async changeTrack(deviceId) {
      let publishStream = await this.webrtc.createVideoorAudioStream(
        deviceId,
        "video",
        "changeDevice"
      );
      if (publishStream && publishStream.code == 1) {
        this.$alert(this.$t('checkCamera.切换失败'));
      } else {
        this.$store.commit("SET_VIDEOINPUTDEVICEID", deviceId);
      }
    },
    async stopVideoTrack() {
      if (this.videoStream && this.videoStream.getVideoTracks()) {
        for (let i = 0; i < this.videoStream.getVideoTracks().length; i++) {
          this.videoStream.getVideoTracks()[i].stop();
        }
        console.log("检测摄像头关闭");
        this.videoStream = null;
      }
    },
  },
};
</script>

<style lang="scss">
.check-nocamera {
  width: 240px;
  height: 134px;
  margin: 20px 0px 0px 70px;
  background-color: $purple-color;
  line-height: 134px;
}
// 修改默认配置
.check-select-device {
  width: 240px;

  .el-popper {
    top: inherit !important;
    left: inherit !important;
  }
  .el-input__inner {
    background-color: transparent !important;
    color: #fff;
    // border-color: #acb2af;
    border-color: #525366;
  }
  .el-select-dropdown {
    // background-color: $purple2-color !important;
    // border: 1px solid $purple4-color;
    li {
      // color: #fff;
      text-align: left;
    }
  }
  // .el-popper[x-placement^="bottom"] .popper__arrow::after {
  //   border-bottom-color: $purple2-color !important;
  // }
  // .el-select-dropdown__item.hover,
  // .el-select-dropdown__item:hover {
  //   background-color: $purple3-color !important;
  // }
  .el-popper[x-placement^="bottom"] .popper__arrow {
    border-bottom-color: $purple4-color;
  }
}
.check-viedo {
  margin-top: 20px;
  border-radius: 4px;
  object-fit: cover;
}
.error_message {
  margin-bottom: 10px;
  color: #ff5d47;
  font-size: 12px;
}
</style>
